export const receiverDictionary = {
  CUS: 'CUS',
  OPS: 'OPS',
  WYK: 'WYK',
  CT24: 'CT24',
} as const;

export type Receivers = keyof typeof receiverDictionary;
